import React, { useEffect, useState } from 'react';
import Header from '../header';
import Footer from '../footer';
import Steper from './components/steper';
import CustomInput from '../../components/customInput';
import { useSelector } from 'react-redux';
import { langSelector } from '../../store/langSlice';
import getEnvironement, { getLang } from '../../environnement';
import CustomButton from '../../components/customButton';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import CustomBackdrop from '../../components/backdrop';

export default function EtatDemandeLogin() {
  const [cin, setCin] = useState('');
  const [numeroDemande, setNumeroDemande] = useState('');

  const [cinError, setCinError] = useState('');
  const [numeroDemandeError, setNumeroDemandeError] = useState('');

  const [openBackdrop, setOpenBackdrop] = useState(false);

  const lang = useSelector(langSelector);
  const navigate = useNavigate();

  async function consulterDemande() {
    const url = `${getEnvironement().API_URL}/consulterDemande`;
    const data = {
      lang,
      cin,
      numeroDemande
    };
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    }

    setOpenBackdrop(true);
    await axios.post(url, data, config)
      .then((res) => {
        setTimeout(() => {
          setOpenBackdrop(false);
        }, 800)
        return res;
      })
      .then((res) => navigate('/suivre-demande', {state : {fromDemandeSalle: false, reservation: res.data.reservation}}))
      .then(() => {
        setCin('');
        setCinError('');
        setNumeroDemande('');
        setNumeroDemandeError('');
      })
      .catch((err) => {
        setOpenBackdrop(false);
        if (err.response.data.errors) {
          err.response.data.errors.cin ? setCinError(err.response.data.errors.cin[0]) : setCinError('');
          err.response.data.errors.numeroDemande ? setNumeroDemandeError(err.response.data.errors.numeroDemande[0]) : setNumeroDemandeError('');
        }
        if (err.response.data.message && err.response.status === 401) {
          setCin('');
          setCinError('');
          setNumeroDemande('');
          setNumeroDemandeError('');
          toast.error(getLang(lang).reservationSalle.demandeCanceled);
        } else {
          if (err.response.data.reservation) {
            setCin('');
            setCinError('');
            setNumeroDemande('');
            setNumeroDemandeError('');
            toast.error(getLang(lang).reservationSalle.cinNumeroDemandeIncorrecte);
          }
        }
      })
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div>
      <ToastContainer />
      <CustomBackdrop open={openBackdrop} setOpen={setOpenBackdrop} />
      <Header />
      <div className='3xl:flex 3xl:justify-center' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none'}}>
        <div className='3xl:w-[1200px] mx-10'>
          <Steper step={2}/>
          <CustomInput
            type='text'
            placeholder={getLang(lang).reservationSalle.cin}
            value={cin}
            setValue={setCin}
            isError={cinError !== ''}
            error={cinError}
          />
          <CustomInput
            type='text'
            placeholder={getLang(lang).reservationSalle.numeroDemande}
            value={numeroDemande}
            setValue={setNumeroDemande}
            isError={numeroDemandeError !== ''}
            error={numeroDemandeError}
          />
          <CustomButton
            value={getLang(lang).reservationSalle.consulterEtatDemande}
            handelClick={consulterDemande}
          />
          <p className='font-inter text-center text-primary font-medium text-2xl sm:text-3xl mb-10 relative bottom-5' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{getLang(lang).reservationSalle.oublierNumeroDemandeInfo}</p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
